import g from '#core/global';
import load from '#core/load';
import layout from '#core/layout';
import util from '#core/util';


const item_$ = '.factsheet-metric-item';
const bar_$ = '.factsheet-metric-item__progress-bar';
const median_$ = '.factsheet-metric-item__progress-median';
const target_width_attr = 'data-target-width';
const target_left_attr = 'data-target-left';

let has_items = false;
let $items = null;
const animated = new Set();


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('factsheet-metric-item')) return false;

		load.content(() => {
			has_items = assign_elements();
			if (!has_items) return false;

			// Someone who asked for reduced motion gets the finished state, not a
			// reveal that waits for them to scroll to it. Every bar and median
			// marker goes straight to its target and no scroll listener is bound.
			if (prefers_reduced_motion()) {
				reveal_all();
				return true;
			}

			assign_scroll_events();
		});
	},

};

export default module;
module.init();


/**
 * Assign elements
 * @return {boolean}
 */
function assign_elements() {
	if (has_items) return true;

	$items = document.querySelectorAll(item_$);
	if (!$items.length) return false;

	check_items();
	return true;
}


/**
 * Does this visitor want reduced motion?
 * @return {boolean}
 */
function prefers_reduced_motion() {
	return typeof window.matchMedia === 'function'
		&& window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}


/**
 * Put every metric straight into its finished state.
 *
 * Also what makes this component screenshot-stable. The bars start at width 0
 * and only fill once their item scrolls into view, on a throttled handler — so
 * whether any given bar is filled when a screenshot is taken depends on the
 * scroll pass and the throttle, and two captures of an unchanged page disagree.
 * Measured 2026-08-25: scorecard-factsheets differed by 0.93% between identical
 * runs, entirely in these bars. Visual-regression capture runs under reduced
 * motion, so honouring it here removes the race at its source and keeps the
 * scorecard inside regression coverage rather than excluding it.
 */
function reveal_all() {
	$items.forEach(($item) => {
		animated.add($item);
		animate_item($item);
	});
}

/**
 * Assign scroll events
 */
function assign_scroll_events() {
	window.addEventListener(g.scroll_e, util.throttle(() => {
		check_items();
	}, 200));
}


/**
 * Check each item for visibility and animate
 */
function check_items() {
	if (!$items) return false;

	$items.forEach(($item) => {
		if (animated.has($item)) return;

		const is_visible = layout.isIntersecting({
			$element: $item,
			lookaround: 0.7,
		});
		if (!is_visible) return;

		animated.add($item);
		animate_item($item);
	});
}


/**
 * Animate progress bar and median marker
 * @param {Element} $item
 */
function animate_item($item) {
	const $bar = $item.querySelector(bar_$);
	const $median = $item.querySelector(median_$);

	if ($bar) {
		const width = $bar.getAttribute(target_width_attr);
		$bar.style.width = width + '%';
	}

	if ($median) {
		const left = $median.getAttribute(target_left_attr);
		$median.style.left = left + '%';
	}
}
